import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";

export default function PromotionActivationSuccess() {
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const listingId = params.get("listingId");

  return (
    <div
      style={{
        maxWidth: "700px",
        margin: "60px auto",
        padding: "30px",
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
        textAlign: "center",
      }}
    >
      <FaCheckCircle
        style={{ fontSize: "70px", color: "#2e7d32", marginBottom: "20px" }}
      />

      <h1 style={{ color: "#2e7d32", marginBottom: "10px" }}>
        Listing Activated
      </h1>

      <p style={{ fontSize: "1.1rem", color: "#555", marginBottom: "15px" }}>
        Your promotion code has been successfully applied.
      </p>

      <p style={{ color: "#555", maxWidth: "520px", margin: "0 auto" }}>
        Your listing is now live on Client Exchange and visible to buyers.
        No upfront activation fee has been charged.
      </p>

      <div
        style={{
          marginTop: "25px",
          padding: "15px",
          background: "#f1f8f4",
          borderRadius: "8px",
          fontSize: "1.05rem",
          color: "#2e7d32",
          fontWeight: "bold",
        }}
      >
        {listingId
          ? `Your Listing ID: ${listingId}`
          : "Your listing is now live."}
      </div>

      <p style={{ marginTop: "12px", color: "#555" }}>
        A confirmation email has been sent with your listing details.
      </p>

      <div
        style={{
          marginTop: "30px",
          padding: "20px",
          background: "#f9fdfb",
          borderRadius: "10px",
          textAlign: "left",
          maxWidth: "520px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <h3 style={{ color: "#2e7d32", marginBottom: "10px" }}>
          What happens next?
        </h3>
        <ul style={{ color: "#555", lineHeight: "1.7", paddingLeft: "20px" }}>
          <li>Your listing is now visible to buyers</li>
          <li>You can manage or edit it from your dashboard</li>
          <li>You’ll receive an email when someone makes an enquiry or purchase</li>
        </ul>
      </div>

      <div style={{ marginTop: "40px", display: "flex", gap: "15px" }}>
        <button
          onClick={() => navigate("/my-listings")}
          style={{
            flex: 1,
            padding: "14px",
            background: "#4caf50",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            fontSize: "1rem",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          Go to My Listings
        </button>

        <button
          onClick={() => navigate("/dashboard")}
          style={{
            flex: 1,
            padding: "14px",
            background: "#0288d1",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            fontSize: "1rem",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}